import { useCallback, useState } from 'react'
import z from 'zod'
import { V2L3ManageEncountersModal } from '@fusion-advantage/formrender'
import { useAppDispatch, useAppSelector } from '../../../redux/hooks'
import { adhocViewEncounter } from '../../../redux/syncthunk/adhocViewEncounterThunk'
import { AppModal, dismissAppModal } from '../../../redux/appSlice'
import { apiAuditAssign, apiAuditReturnTo } from '../../../redux/apithunk/apiAudit'
import { appSync } from '../../../redux/syncthunk/syncThunk'
import { UserRole } from '@fusion-advantage/backcompat'
import { canViewAdhocEncounters, WorkItemAction } from '@fusion-advantage/formlib'
import { SyncType } from '../../../redux/syncthunk/SyncConfig'
import { saveAndReturnToDashboard } from '../../../redux/thunk/renderInstanceStore'
import { selectOpIsBlockingEncounterMgmt } from '../../../redux/selectDashboardLoading'

const checkGuid = (guid: string): boolean => {
	const rParse = z.uuid().safeParse(guid)
	if(!rParse.success) {
		alert('Invalid Encounter GUID, please try again.')
		return false
	}
	return true
}

export const LxManageEncountersModal = () => {
	const opIsBlockingEncounterMgmt = useAppSelector(selectOpIsBlockingEncounterMgmt)
	const authedIdentity = useAppSelector(state => state.dashboardData.authedIdentity)
	const dispatch = useAppDispatch()
	const [encounterGuid, setEncounterGuid] = useState<string>('')
	const handleViewClick = useCallback(async () => {
		if(!checkGuid(encounterGuid)) {
			return
		}
		dispatch(adhocViewEncounter({
			syncType: SyncType.Dashboard,
			encounterGuid,
			action: WorkItemAction.ViewFormAsAuditor,
		}))
		dispatch(dismissAppModal(AppModal.ManageEncounters))
	}, [encounterGuid])
	const handlePickClick = useCallback(async () => {
		if(!checkGuid(encounterGuid)) {
			return
		}
		const r = await dispatch(apiAuditAssign(encounterGuid))
		if(r.isErr()) {
			// error message already displayed,
			// nothing further to do
			return
		}
		if(!r.value) {
			alert('Did not assign; please contact Dan.')
			return
		}
		dispatch(saveAndReturnToDashboard())
		dispatch(appSync({
			type: SyncType.Dashboard,
		}))
		dispatch(dismissAppModal(AppModal.ManageEncounters))
	}, [encounterGuid, dispatch])
	const handleReturnToClick = useCallback(async () => {
		if(!checkGuid(encounterGuid)) {
			return
		}
		const r = await dispatch(apiAuditReturnTo(encounterGuid))
		if(r.isErr()) {
			// error message already displayed,
			// nothing further to do
			return
		}
		if(!r.value) {
			alert('Did not return to audit; please contact Dan.')
			return
		}
		dispatch(saveAndReturnToDashboard())
		dispatch(appSync({
			type: SyncType.Dashboard,
		}))
		dispatch(dismissAppModal(AppModal.ManageEncounters))
	}, [encounterGuid, dispatch])
	const canAudit = Boolean(authedIdentity?.roles.includes(UserRole.AUDITOR))
	const canViewAdhoc = canViewAdhocEncounters(authedIdentity)
	return (
		<V2L3ManageEncountersModal
			canViewAdhoc={canViewAdhoc}
			canAudit={canAudit}
			loading={opIsBlockingEncounterMgmt}
			value={encounterGuid}
			onChange={(e) => setEncounterGuid(e.target.value.toUpperCase())}
			onViewClick={handleViewClick}
			onPickClick={handlePickClick}
			onReturnClick={handleReturnToClick}
			onDismissClick={() => dispatch(dismissAppModal(AppModal.ManageEncounters))}
		/>
	)
}
